import * as Configuration from '../../../app.constants.js';

ReportsController.$inject = ['$scope', 'company'];
export function ReportsController($scope, company) {
  init();

  function init() {
    $scope.iframeUrl = Configuration.constants.baseUrl + company.id +
      '/parameters/reports/ifr-content';
  }
}